import IStateAdjustment from '../state/IStateAdjustment';

class ResponseSendingAdjustment implements IStateAdjustment {
  //private readonly re = new RegExp('version|time|attempts|attempted|(RESPONSE-\\d+)');

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  adjustState(json: JSON): void {
    // for (const key of Object.keys(json)) {
    //   if (!this.re.test(key)) {
    //     delete json[key];
    //   }
    // }
  }
}

export default ResponseSendingAdjustment;
